var _rect, _path, _circle, _circle2, _circle3, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProductCartRed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 50,
    fill: "#FFF5F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.0755 59.6632H67.8797C68.253 59.6632 68.5952 59.4553 68.7672 59.124L79.0733 39.2753C79.4189 38.6096 78.9358 37.8145 78.1858 37.8145H34.4536",
    stroke: "#D91F05",
    strokeWidth: 2.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 45.378,
    cy: 71.1768,
    r: 3.79202,
    stroke: "#D91F05",
    strokeWidth: 2.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 57.9829,
    cy: 71.1768,
    r: 3.79202,
    stroke: "#D91F05",
    strokeWidth: 2.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.4285,
    cy: 26.218,
    r: 2.10084,
    fill: "#D91F05"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0083 25.209H27.731C29.2716 25.209 31.895 26.421 32.773 30.8112C33.6133 35.0129 37.3949 53.8427 39.4957 62.5573C39.9159 64.1134 41.8486 67.2258 46.2184 67.2258C50.5881 67.2258 55.322 67.2258 57.1428 67.2258",
    stroke: "#D91F05",
    strokeWidth: 2.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductCartRed);
export default __webpack_public_path__ + "static/media/productCartRed.f85cf3dccafd083a6f1b28d10b312a76.svg";
export { ForwardRef as ReactComponent };